package learning.containers


import com.jingfangpai.api.clients.ContentApiClient
import com.jingfangpai.common.orm.mapping.enums.ContentType
import community.components.TopicView
import learning.components.TcmFaqView
import react.*
import react.dom.div
import setTitle

external interface TcmFaqViewPageProps : RProps {
    var id:String
}

data class TcmFaqViewPageContextData(var getContent:(type: ContentType, id:kotlin.String, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.content.model.ContentVo>) -> Unit, errorCallback: (exception:Throwable) -> Unit) -> Unit)

val TcmFaqViewPageContext = createContext(TcmFaqViewPageContextData(ContentApiClient::getContent))

val TcmFaqViewPageProvider = functionalComponent<TcmFaqViewPageProps> { props ->

    setTitle("常见问题")

    useEffectOnce { }

    TcmFaqViewPageContext.Provider(TcmFaqViewPageContextData(ContentApiClient::getContent)) {
        div("TcmFaqViewPage-page") {
            child(TcmFaqView) {
                attrs{
                    id = props.id
                }
            }
        }
    }
}
